module.exports = __webpack_public_path__ + "static/img/logo.adb6577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-nav/logo.png
// module id = LvSN
// module chunks = 1